// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AttachmentsViewController from "./attachments_view_controller"
application.register("attachments-view", AttachmentsViewController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BirthDayController from "./birth_day_controller"
application.register("birth-day", BirthDayController)

import ClearInputController from "./clear_input_controller"
application.register("clear-input", ClearInputController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import EventCoverController from "./event_cover_controller"
application.register("event-cover", EventCoverController)

import EventLinksController from "./event_links_controller"
application.register("event-links", EventLinksController)

import InvestmentTransactionKindController from "./investment_transaction_kind_controller"
application.register("investment-transaction-kind", InvestmentTransactionKindController)

import ListEditorController from "./list_editor_controller"
application.register("list-editor", ListEditorController)

import LoadingToggleController from "./loading_toggle_controller"
application.register("loading-toggle", LoadingToggleController)

import MemberSearchController from "./member_search_controller"
application.register("member-search", MemberSearchController)

import MovePickerController from "./move_picker_controller"
application.register("move-picker", MovePickerController)

import NavActiveController from "./nav_active_controller"
application.register("nav-active", NavActiveController)

import NoteAttachmentUploaderController from "./note_attachment_uploader_controller"
application.register("note-attachment-uploader", NoteAttachmentUploaderController)

import NoteDetailsController from "./note_details_controller"
application.register("note-details", NoteDetailsController)

import NoteDropController from "./note_drop_controller"
application.register("note-drop", NoteDropController)

import NoteTreeController from "./note_tree_controller"
application.register("note-tree", NoteTreeController)

import NotesGroupingController from "./notes_grouping_controller"
application.register("notes-grouping", NotesGroupingController)

import PageContentController from "./page_content_controller"
application.register("page-content", PageContentController)

import RangeController from "./range_controller"
application.register("range", RangeController)

import ReorderController from "./reorder_controller"
application.register("reorder", ReorderController)

import SubnoteToggleController from "./subnote_toggle_controller"
application.register("subnote-toggle", SubnoteToggleController)

import TableCellsController from "./table_cells_controller"
application.register("table-cells", TableCellsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TrixContentController from "./trix_content_controller"
application.register("trix-content", TrixContentController)

import TrixFullscreenController from "./trix_fullscreen_controller"
application.register("trix-fullscreen", TrixFullscreenController)

import TrixUploaderController from "./trix_uploader_controller"
application.register("trix-uploader", TrixUploaderController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TurboProgressBarController from "./turbo_progress_bar_controller"
application.register("turbo-progress-bar", TurboProgressBarController)
